import { render, staticRenderFns } from "./DeliveryOrderProviderSync.vue?vue&type=template&id=f41dd1fa&scoped=true&"
import script from "./DeliveryOrderProviderSync.vue?vue&type=script&lang=js&"
export * from "./DeliveryOrderProviderSync.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryOrderProviderSync.vue?vue&type=style&index=0&id=f41dd1fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f41dd1fa",
  null
  
)

export default component.exports